"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingStatus = void 0;
exports.ShippingStatus = {
    Completed: 'COMPLETED',
    Confirmed: 'CONFIRMED',
    Received: 'RECEIVED',
    Created: 'CREATED',
    OnHold: 'ONHOLD',
    Backorder: 'BACKORDER',
    Unprocessed: 'UNPROCESSED',
    Cancelled: 'CANCELLED',
    Delivered: 'DELIVERED',
    Shipped: 'SHIPPED',
    Verified: 'VERIFIED',
};
